import LoomLeadList from './LoomLeadList';
import LoomLeadDetail from './LoomLeadDetail';
import Status from './Status';
import CallStatus from './CallStatus';
import MatchDifficulty from './MatchDifficulty';
import LeadQuality from './LeadQuality';

export default {
  LoomLeadList,
  LoomLeadDetail,
  Status,
  CallStatus,
  MatchDifficulty,
  LeadQuality,
};
